import selectAll from './selectAll';

const hasOnTouchStart = 'ontouchstart' in document.documentElement;
const dropdowns = selectAll('.js-dropdown');

dropdowns.forEach((el) => {
  const parentEl = el.parentNode;

  el.addEventListener('click', () => {
    parentEl.classList.toggle('open');

    if (hasOnTouchStart && parentEl.classList.contains('open')) {
      let clickCatcher = document.createElement('div');
      clickCatcher.classList.add('dropdown-click-catcher');
      parentEl.insertBefore(clickCatcher, el);

      clickCatcher.addEventListener('click', () => {
        parentEl.classList.remove('open');
        selectAll('.dropdown-click-catcher').forEach((d) => d.parentNode.removeChild(d));
      });
    }
  });

  document.addEventListener('click', (e) => {
      const clickedEl = e.target;

      const isSameEl = clickedEl === el;
      const isInParentEl = parentEl.contains(clickedEl);

      if (!isSameEl && !isInParentEl) {
        parentEl.classList.remove('open');
      }
  });
});



/** WEBPACK FOOTER **
 ** ./dropdown.js
 **/